export const alt = 'Arpinet mobile tv application';



